import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=e84cd732&scoped=true"
import script from "./CreateDialog.vue?vue&type=script&lang=js"
export * from "./CreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84cd732",
  null
  
)

export default component.exports